var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ block: true, 'with-border': _vm.withBorder, 'overflow-hidden': _vm.overflowHidden },style:({ padding: `${_vm.padding}px` })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }